import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createBrowserRouter } from "react-router";
import { Toaster } from "sonner";
import { routes } from "./routes";
import { RouteError } from "./components/route-error";
import { reloadForNewBuild } from "./lib/stale-build";
import { useTheme } from "./lib/theme";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 15_000, refetchOnWindowFocus: true, retry: 1 },
  },
});

// A page file from an older deploy failed to load: reload once to get the current build.
window.addEventListener("vite:preloadError", () => {
  reloadForNewBuild();
});

const router = createBrowserRouter(routes.map((r) => ({ ...r, errorElement: <RouteError /> })));

function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster theme={theme} position="top-right" richColors closeButton toastOptions={{ style: { fontFamily: "inherit" } }} />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <ThemedToaster />
    </QueryClientProvider>
  </StrictMode>,
);
